export function DealershipTemplateCtrl (
  $scope,
  $state,
  $translate,
  confirm,
  messages,
  workshopAPI,
  bodyTypes,
  company,
  driveTypes,
  franchises,
  fuelTypes,
  template,
  transmissionTypes
) {

  $scope.bodyTypes         = bodyTypes;
  $scope.company           = company;
  $scope.driveTypes        = driveTypes;
  $scope.franchises        = franchises;
  $scope.fuelTypes         = fuelTypes;
  $scope.template          = template;
  $scope.transmissionTypes = transmissionTypes;

  $scope.delete = function () {
    confirm.generic($translate.instant('JS_SPACE.CONFIRM.DELETE_UNIT_TEMPLATE'))
      .then(function () {
        return workshopAPI.delete('/vehicle_template', $scope.template.id);
      }).then(function () {
        messages.show($translate.instant('JS_SPACE.MESSAGES.DELETED.UNIT_TEMPLATE'), 'success');
        $state.go('app.dealership.templates');
      }).catch(function (err) {
        messages.error(err);
      });
  }

  $scope.save = function () {
    var method = $scope.template.id ? 'patch': 'post';

    workshopAPI[method]('/vehicle_template', $scope.template, 'vehicle_template')
      .then(function (data) {
        $scope.template.id ?
          $state.reload():
          $state.go('app.dealership.template', {
            id: data.id
          });

        messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.UNIT_TEMPLATE'), 'success');
      }).catch(function (err) {
        messages.error(err);
      });
  }
};